import ReactLoading from 'react-loading'
const ButtonDef = ({ id, label, isShadow, icons, variant, onClick, loading, disabled, height, styles, title }) => {
    // console.log(loading)
    return (
        <div className={`btn-def-shadow btn-shadow-${variant}${(loading) ? ` btn-loading` : ``} ${(disabled) ? ` disabled` : ``}`} style={{ minHeight: 30, minWidth: 100 }}>
            <button
                className={`btn-def btn-def-${variant}${(disabled) ? ` disabled` : ``}`}
                id={id}
                onClick={onClick}
                style={{ height: (height) ? height : null, ...styles }}
                title={title}
            >
                {(loading) && (
                    <ReactLoading className="loading-icon" type="spin" color={"#a4a4a4"} height={24} width={36} />
                )}
                {(icons) && (<img src={icons} alt={variant} style={{ marginRight: 12, marginTop: -3 }} />)}
                {(label) && (<span style={{ marginTop: 3, fontSize: 14 }}>{label}</span>)}
            </button>
            {(isShadow) && (
                <div className="shadow-line"></div>
            )}
        </div>
    )
}

export default ButtonDef;